export default __webpack_public_path__ + "static/media/wrong.73146ed4.png";